import styled from "styled-components";
import { Box } from "grommet";

const PrintHideBox = styled(Box)`
  @media print {
    display: none;
  }
  @page { 
    size: A4; 
    margin: 0mm;
  }
`

export { PrintHideBox }